import axios from "axios";

window.axios = axios;

window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.headers.common["X-Product-Version"] = "1.0.0";
window.axios.defaults.headers.common["Access-Control-Allow-Headers"] = "*";
window.axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("token");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Content-Type"] = "application/json";
window.axios.defaults.rejectUnauthorized = false;
// window.axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
// window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

window.axios.defaults.baseURL = "https://nsamp2.epic-group.net/api/";
